import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { db } from './FirestoreDataLoader.tsx'; 
import { doc, getDoc, Timestamp,arrayUnion, runTransaction, serverTimestamp, deleteField  } from 'firebase/firestore';


interface InviteData {
  token: string | null;
  emailInv: string | null;
  ruolo: 'azienda' | 'collaboratore' | 'cliente' | null;
  isLoad: boolean;
  error: string | null;
}


/*export const useInviteTokenVerification = () => {
  const location = useLocation();

  // Inizializza dallo storage
  const [inviteData, setInviteData] = useState<InviteData>(() => {
    const saved = sessionStorage.getItem('inviteData');
    if (saved) {
      try {
        return JSON.parse(saved) as InviteData;
      } catch {
        return { token: null, emailInv: null, ruolo: null, isLoad: true, error: null };
      }
    }
    return { token: null, emailInv: null, ruolo: null, isLoad: true, error: null };
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenFromUrl = queryParams.get('token');
    const tokenFromSession = sessionStorage.getItem('inviteData')
      ? JSON.parse(sessionStorage.getItem('inviteData')!).token
      : null;

    // Determina il token effettivo
    const effectiveToken = tokenFromUrl || tokenFromSession;

    // Nessun token 
    if (!effectiveToken) {
      const normalUserData: InviteData = {
        token: null,
        emailInv: null,
        ruolo: null,
        isLoad: true,
        error: null,
      };
      setInviteData(normalUserData);
      sessionStorage.setItem('inviteData', JSON.stringify(normalUserData));
      return;
    }

    // Token presente
    const handleVerification = async () => {
      try {
        const inviteRef = doc(db, 'inviti', effectiveToken);
        const docSnapshot = await getDoc(inviteRef);

        if (!docSnapshot.exists()) {
          throw new Error('Invito non valido o inesistente.');
        }

        const data = docSnapshot.data();
        const now = Timestamp.now();

        if (data.dataScadenza?.toMillis() < now.toMillis()) {
          throw new Error("L'invito è scaduto.");
        }

        if (data.stato === 'Registrato') {
          throw new Error("Questo invito è già stato utilizzato.");
        }

        const verifiedData: InviteData = {
          token: effectiveToken,
          emailInv: data.email,
          ruolo: data.ruolo,
          isLoad: true,
          error: null,
        };

        setInviteData(verifiedData);
        sessionStorage.setItem('inviteData', JSON.stringify(verifiedData));
      } catch (err: any) {
        const errorMsg = err.message || 'Errore durante la verifica del token.';
        const errorData: InviteData = {
          token: null,
          emailInv: null,
          ruolo: null,
          isLoad: true,
          error: errorMsg,
        };
        setInviteData(errorData);
        sessionStorage.setItem('inviteData', JSON.stringify(errorData));
      }
    };

    handleVerification();
  }, [location.search]);

  return inviteData;
};*/




export const finalizeInviteFrontend = async (
    inviteToken: string, 
    newUserId: string, 
    ruolo: 'azienda' | 'collaboratore' | 'cliente',
) => {
    // Determina il nome della mappa da aggiornare nell'utente invitante
    let arrayInvitati: string;
    switch (ruolo) {
        case 'collaboratore':
            arrayInvitati = 'collaboratori_invitati';
            break;
        case 'cliente':
            arrayInvitati = 'clienti_invitati';
            break;
        case 'azienda':
            arrayInvitati = 'aziende_invitate';
            break;
        default:
            alert("Ruolo non valido per la finalizzazione dell'invito.");
    }

    try {
        await runTransaction(db, async (transaction) => {
            
            // Aggiorna lo stato dell'Invito
            const inviteRef = doc(db, 'inviti', inviteToken);
            const docSnapshot = await getDoc(inviteRef)
            const tokenDoc = docSnapshot.data();

            const invitanteId = tokenDoc?.invitanteId;
            const emailInvitato = tokenDoc?.email
            
            // Per sicurezza, rileggiamo lo stato 
            const inviteDoc = await transaction.get(inviteRef);
            if (!inviteDoc.exists() || inviteDoc.data()?.stato !== 'inviato') {
                // Preveniamo l'uso di un invito già Registrato/scaduto
                 throw new Error("Invito non più nello stato 'inviato'.");
            }
            //cancelliamo il documento nominato con il token.
            transaction.delete(inviteRef);

            // Aggiorna il Profilo dell'Utente che ha Invitato
            const invitanteRef = doc(db, 'utenti', invitanteId);
            
            // Aggiungi il nuovo utente all'array degli invitati
            const updateData: any = {
                 [arrayInvitati]: arrayUnion(newUserId) 
            };
            
            // Cancella la mappa che ha come nome l'email dentro 'inviti_emessi'
            const campoDaCancellare = `inviti_emessi.${emailInvitato}`;
            updateData[campoDaCancellare] = deleteField();
            
            transaction.update(invitanteRef, updateData);
            
        });
        return { success: true };

    } catch (error) {
        return { success: false, error };
    }
};